import React from 'react';

function CartasAlmacen(props) {

    return (
  <div className="row d-flex justify-content-between">
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
    <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        {props.titulo1 !== '' ? props.titulo1 : 'Almacen'}
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-center px-md-1 pb-2">
          <h1 className='text-right'>{props.total1 !== '' ? props.total1 : 'Total'} </h1>
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
    <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-center px-md-1 pb-2">
         
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
    <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-center px-md-1 pb-2">
         
        </div>
      </div>
    </div>
  </div>
</div>

  );
}

export default CartasAlmacen;


// WEBPACK FOOTER //
// ./src/components/almacen/cartas/cartas.js